import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "components/Layout/Card";
// import HeaderLayout from "components/Layout/HeaderLayout";
import { researcherTypes } from "utils/constants";
import SliderLayout from "pages/Auth/SliderLayout/SliderLayout";
import "./Selection.scss";

// Student and Professional are one choice for the member ("Membership for Researchers").
// The researcher type they pick decides which account type is created behind the scenes.
const joinAsOptions = [
  {
    key: "researchers",
    title: "Membership for Researchers",
    description: "Academicians, Researchers, UG/PG Students, Corporate individuals",
  },
  {
    key: "institutional",
    title: "Institutional Member",
    description: "Universities/Colleges/Institutions",
    memberType: "institutional",
  },
];

const Selection = () => {
  const navigate = useNavigate();
  const [isResearcherStep, setIsResearcherStep] = useState(false);

  const goToRegister = (memberType) => navigate(`/${memberType}/member/register`);

  const options = isResearcherStep ? researcherTypes : joinAsOptions;

  return (
    <div id="selection-container">
      <SliderLayout isSelection>
        <Card className="m-auto card-padding">
          <div className="text-center text-26-500 cmb-30 font-poppins">
            {isResearcherStep ? "What type of researcher are you?" : "Join As"}
          </div>
          {options.map((elem) => {
            const onSelect = () => {
              if (!isResearcherStep && elem.key === "researchers") {
                setIsResearcherStep(true);
                return;
              }
              goToRegister(elem.memberType);
            };
            return (
              <div className="arrow-block" key={elem.key || elem.title}>
                <div>
                  <div className="text-18-500 color-raisin-black mb-2 font-poppins">
                    {elem.title}
                  </div>
                  {elem.description && (
                    <div className="text-14-400 color-raisin-black text-break">
                      {elem.description}
                    </div>
                  )}
                </div>
                <div className="r-icon-block" onClick={onSelect}>
                  <i className="bi bi-chevron-right text-20-500 color-new-car" />
                </div>
              </div>
            );
          })}
          {isResearcherStep && (
            <div
              className="text-14-500 color-new-car pointer text-center cmt-10"
              onClick={() => setIsResearcherStep(false)}
            >
              ← Back
            </div>
          )}
        </Card>
      </SliderLayout>
    </div>
  );
  // return (
  //   <HeaderLayout>
  //     <div id="selection-container">
  //       <div className="row">
  // <div className="m-auto text-center">
  //   <div className="text-center text-32-600 color-raisin-black cmb-20">
  //     IFERP Membership
  //   </div>
  //   <div className="text-center text-16-400 color-raisin-black mb-5">
  //     Become an IFERP Member to get connected with engineers and
  //     researchers
  //   </div>
  // </div>
  // <Card className="col-md-5 col-md-3 m-auto card-padding">
  //   <div className="text-center text-28-500 cmb-30">Join As</div>
  //   {membershipType.map((elem, index) => {
  //     return (
  //       <div
  //         className={`arrow-block ${
  //           ["0", "6"].includes(elem.id) ? "d-none" : ""
  //         }`}
  //         key={index}
  //       >
  //         <div>
  //           <div className="text-18-500 color-raisin-black mb-2">
  //             {elem.title}
  //           </div>
  //           <div className="text-14-400 color-raisin-black text-break">
  //             {elem.description}
  //           </div>
  //         </div>
  //         <div
  //           className="r-icon-block"
  //           onClick={() => {
  //             navigate(`/${elem.type}/member/register`);
  //           }}
  //         >
  //           <i className="bi bi-chevron-right text-20-500 color-new-car" />
  //         </div>
  //       </div>
  //     );
  //   })}
  // </Card>
  //       </div>
  //     </div>
  //   </HeaderLayout>
  // );
};
export default Selection;
